import type { IWorkspaceDB } from '../../db/interface';
import type { ILanguageDto, IModelSource, ISiteDto } from '../../model/interface';

async function SiteSupportedLanguages(
    database: IWorkspaceDB,
    site?: ISiteDto,
): Promise<ILanguageDto[]> {
    const siteLookup = site ?? (await database.first('ISiteDto'));

    const siteSupportedLanguages = await database.all('ISiteSupportedLanguageDto');

    const languageIds = siteSupportedLanguages
        .filter(ssl => ssl.siteId === siteLookup.id)
        .map(ssl => ssl.languageId);

    const languages = await Promise.all(languageIds.map(id => database.get('ILanguageDto', id)));

    return languages;
}

async function allLanguagesUsedInTours(database: IWorkspaceDB): Promise<ILanguageDto[]> {
    const tours = await database.all('ITourDto');
    const tourLanguages = await Promise.all(
        tours.map(tour => tour.tourSupportedLanguages(database as IModelSource)),
    );
    const allSiteSupportedLanguages = await Promise.all(
        tourLanguages.flat().map(tsl => tsl.siteSupportedLanguage(database as IModelSource)),
    );

    const allSiteSupportedLanguageIds: number[] = [];
    const siteSupportedLanguages = allSiteSupportedLanguages.filter(ssl => {
        if (allSiteSupportedLanguageIds.includes(ssl.id)) {
            return false;
        } else {
            allSiteSupportedLanguageIds.push(ssl.id);
            return true;
        }
    });

    const languages = await Promise.all(
        siteSupportedLanguages.map(siteSupportedLanguage =>
            siteSupportedLanguage.language(database as IModelSource),
        ),
    );

    return languages;
}

export default Object.freeze({
    SiteSupportedLanguages,
    allLanguagesUsedInTours,
});
